import { FiX } from "react-icons/fi";
import MarkdownPreview from '@uiw/react-markdown-preview';

const FullViewAdminTableModal = ({ item, onClose }) => {
  if (!item) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 overflow-auto">
      <div className="bg-white p-6 rounded-lg w-[700px] max-h-[80vh] overflow-y-auto relative">

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-red-800 bg-gray-200 p-2 rounded-full hover:bg-gray-300"
        >
          <FiX size={32} />
        </button>

        <h2 className="text-xl font-bold mb-4">Full Item Details</h2>

        <table className="table-auto w-full border-collapse border border-gray-300">
          <tbody>
            {Object.entries(item).map(([key, value]) => (
              <tr key={key} className="border border-gray-200">
                <td className="p-3 font-medium capitalize border">{key}</td>
                {key === 'descriptions' ? (
                  <td className="p-3 border">
                    <MarkdownPreview source={String(value)} />
                  </td>
                ) : (
                  <td className="p-3 border">{String(value)}</td>
                )}

              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FullViewAdminTableModal;
